import { render } from "./SwitchInput.vue?vue&type=template&id=2deca7ee&scoped=true"
import script from "./SwitchInput.vue?vue&type=script&lang=js"
export * from "./SwitchInput.vue?vue&type=script&lang=js"

import "./SwitchInput.vue?vue&type=style&index=0&id=2deca7ee&scoped=true&lang=css"

import exportComponent from "/home/lexmodo/projects/waitlist/waitlist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2deca7ee"]])

export default __exports__